import { render, staticRenderFns } from "./DinamicaRelacao.vue?vue&type=template&id=41ccb0ce"
import script from "./DinamicaRelacao.vue?vue&type=script&lang=js"
export * from "./DinamicaRelacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports